import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private defaultConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'center',
    verticalPosition: 'bottom'
  };

  constructor(private snackBar: MatSnackBar) {}

  /**
   * Show error message in snackbar
   * @param message Error message to display
   * @param action Optional action text
   */
  showError(message: string, action = 'Sulje'): void {
    const config: MatSnackBarConfig = {
      ...this.defaultConfig,
      panelClass: `snackbar-error`,
      duration: 8000
    };

    this.snackBar.open(message, action, config);
  }

  /**
   * Get user-friendly error message based on HTTP error
   * @param error The HTTP error response
   * @returns Localized user-friendly error message
   */
  getErrorMessage(error: HttpErrorResponse): string {
    // Default error messages based on HTTP status
    // TODO: Re-think the messages based on application's needs
    switch (error.status) {
      case 401:
        return 'Kirjautuminen on vanhentunut. Ole hyvä ja kirjaudu uudelleen.';
      case 403:
        return 'Sinulla ei ole oikeuksia tähän toimintoon.';
      case 404:
        return 'Pyydettyä resurssia ei löytynyt.';
      case 409:
        return 'Tietojen tallennus epäonnistui (konfliktitilanne).';
      case 422:
        return 'Lähetetyt tiedot ovat virheelliset.';
      case 500:
        return 'Palvelimella tapahtui virhe. Yritä myöhemmin uudelleen.';
      default: {
        // Try to get a message from the response
        const serverMessage = error.error?.message || error.message;
        return serverMessage || 'Tapahtui odottamaton virhe.';
      }
    }
  }

  /**
   * Handle HTTP errors and show appropriate message
   * @param error The HTTP error response
   * @param customMessage Optional custom message to show instead of default
   */
  handleHttpError(error: HttpErrorResponse, customMessage?: string): void {
    console.error('API Error:', error);

    const message = customMessage || this.getErrorMessage(error);
    this.showError(message);
  }
}
